import React from 'react';
import TopBarChinese from "../components/TopBarChinese";
import FooterChinese from "../components/FooterChinese";
import "../App.css";
import ContactFormChinese from '../components/ContactFormChinese';

function AboutUsChinese() {
  return (
    <div className="App">
      <TopBarChinese />
      <div className="App-header-services" style={{ padding: '8vw 8px 8px 8px', marginBottom: '10vh' }}>
        <div className="about-us-text" style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
          <h1 className="hero-title">關於我們</h1>
          <p className="hero-subtitle" style={{ fontSize: '1.2rem', color: '#333', marginBottom: '32px' }}>
擁有近十年長照服務經驗，我們深刻理解照顧者所面臨的壓力，也堅信照顧他人不僅是一項服務， 更是一份使命。

在 Connection Health Care（CHC），我們的使命是提供具有同理心、值得信賴且貼近需求的照護服務，致力於守護每位服務對象的尊嚴、舒適與身心福祉。更重要的是，我們希望協助主要照顧者減輕負擔，讓整個家庭即使面對親人需要更多照

護，也能維持原有的生活品質與步調。我們的專業團隊涵蓋照顧服務員、居家照護員、護理人員、家事服務員與其他長照相關背景的專才。這樣多元且具有愛心的組合，讓我們能因應從日常生活協助到複雜照護需求的各種情況，提供完善而靈活的

服務。在 CHC，我們以待家人的心照顧每一位個案。我們用心了解每位服務對象的生命故事、生活習慣與個人目標，確保我們的照護服務不僅提升生活品質，更為家庭帶來安心與信任。

秉持專業、關懷與尊重的核心價值，CHC 致力於讓每一天都更加安全、溫暖且有意義。我們在這裡，陪伴您最愛的人，也為您帶來應得的喘息與支持。

          </p>
          <div style={{ margin: '40px auto', maxWidth: '800px', width: '100%' }}>
            <img 
              src="/caring8.jpg"
              alt="Connection Health Care Team" 
              style={{ 
                width: '100%', 
                height: 'auto', 
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
              }} 
            />
          </div>   
          <p style={{ fontSize: '1rem', color: '#555' }}>
「無論做甚麼，都要從心裡去做，像是給主做的，不是給人做的。」— 歌羅西書 3:23          
          </p>
        </div>
      </div>
      <ContactFormChinese />
      <FooterChinese />
    </div>
  );
}

export default AboutUsChinese;